module.exports = __webpack_public_path__ + "static/legacy_bn1M@2x-fc0362036ecf3adc1e3aaeb856c9034d.jpg";